<template>
  <b-row>
    <b-col>
      <div class="ibox">
        <div class="ibox-title">
          <i class="far fa-shopping-cart"></i>
          Commandes
          <span v-if="total !== null" class="text-muted">({{ total }})</span>
        </div>
        <div class="ibox-content">
          <div class="table-wrapper">
            <b-table hover show-empty :busy="isBusy" :fields="fields" :items="rentings">
              <template slot="empty">
                <div class="text-center mt-2">Aucune commande sur cette affaire</div>
              </template>
              <template slot="renting_number" slot-scope="data">
                <router-link :to="{ name: 'RentingDetail', params: { id: data.item.id } }" target="_blank">{{
                  data.item.renting_number
                }}</router-link>
              </template>
              <template slot="axiloc_creation_date" slot-scope="data">{{ formatDate(data.item.axiloc_creation_date) }}</template>
              <template slot="wished_delivery_date" slot-scope="data">{{ formatDate(data.item.wished_delivery_date) }}</template>
              <template slot="end_renting_date" slot-scope="data">{{ formatDate(data.item.end_renting_date) }}</template>
              <template slot="employee" slot-scope="data">{{
                data.item.employee ? data.item.employee.firstname + " " + data.item.employee.lastname : "-"
              }}</template>
              <template slot="status" slot-scope="data">{{ data.item.status ? data.item.status.name : "-" }}</template>
            </b-table>
          </div>
          <b-pagination
            v-if="total > perPage"
            v-model="page"
            :total-rows="total"
            :per-page="perPage"
            align="center"
            class="mt-3"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
// Commandes de l'affaire, paginées côté API (`GET renting?business=<id>`) : une affaire peut en
// porter plus d'un millier.
export default {
  name: "BusinessRentings",
  props: {
    businessId: { type: [Number, String], required: true },
  },
  data() {
    return {
      rentings: [],
      total: null,
      page: 1,
      perPage: 20,
      isBusy: false,
      fields: [
        { key: "renting_number", label: "N° commande" },
        { key: "axiloc_creation_date", label: "Création" },
        { key: "wished_delivery_date", label: "Livraison souhaitée" },
        { key: "end_renting_date", label: "Fin de location" },
        { key: "employee", label: "Demandeur" },
        { key: "status", label: "Statut" },
      ],
    };
  },
  watch: {
    page() {
      this.load();
    },
    businessId() {
      this.page = 1;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.isBusy = true;
      this.$http
        .get(process.env.BACK_API_URL + "renting", {
          params: {
            business: this.businessId,
            page: this.page,
            limit: this.perPage,
            sortBy: "axiloc_creation_date",
            sortDesc: "DESC",
          },
        })
        .then((response) => {
          // 204 sans contenu : aucune commande
          this.rentings = (response.data && response.data.rentings) || [];
          this.total = (response.data && response.data.total) || 0;
        })
        .catch(() => {
          this.rentings = [];
          this.total = 0;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    formatDate(value) {
      return value ? this.$moment(value).format("DD/MM/YYYY") : "-";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Business/BusinessRentings.vue